"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const x_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/x.svg"));
const facebook_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/facebook.svg"));
const embed_credential_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/embed-credential.svg"));
const whatsapp_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/whatsapp.svg"));
const yammer_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/yammer.svg"));
const three_dot_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/three-dot.svg"));
const xing_svg_1 = __importDefault(require("../../../../../assets/images/socialIcons/xing.svg"));
const react_share_1 = require("react-share");
const ConditionalWrapper_1 = __importDefault(require("../../../../common/conditionalWrapper/ConditionalWrapper"));
const master_1 = require("../../../../../constants/master");
const constants_1 = require("../../../../../constants");
const Events_1 = require("../../../../../services/backend/Events");
const constants_2 = require("../../../../../constants/constants");
const react_detect_click_outside_1 = require("react-detect-click-outside");
const actionShareButtonsTypes_1 = require("./actionShareButtonsTypes");
const Vcl_1 = require("../../../../../services/backend/Vcl");
const Notification_1 = __importDefault(require("../../../../../elementKit/notification/Notification"));
const ElementBaseConfig_1 = require("../../../../../config/ElementBaseConfig");
const Certificate_1 = require("../../../../../services/backend/Certificate");
const react_svg_1 = require("react-svg");
const BaseButton_1 = __importDefault(require("../../../../../elementKit/baseButton/BaseButton"));
const ImsJsonEmbedModal_1 = __importDefault(require("../../../imsJsonModal/ImsJsonEmbedModal"));
function ActionShareButtons(props) {
    var _a, _b, _c;
    const [shareDropdownOpen, setShareDropdownOpen] = (0, react_1.useState)(false);
    const [disclosureId, setDisclosureId] = (0, react_1.useState)(0);
    const [disclosureUrl, setDisclosureUrl] = (0, react_1.useState)("");
    const [disclosureShareText, setDisclosureShareText] = (0, react_1.useState)("");
    const [sharingFor, setSharingFor] = (0, react_1.useState)("");
    const [disclosure, setDisclosure] = (0, react_1.useState)(null);
    const [certificateEmbedLink, setCertificateEmbedLink] = (0, react_1.useState)();
    const [badgeEmbedLink, setBadgeEmbedLink] = (0, react_1.useState)();
    const twitterRef = (0, react_1.useRef)(null);
    const facebookRef = (0, react_1.useRef)(null);
    const xingRef = (0, react_1.useRef)(null);
    const whatsappRef = (0, react_1.useRef)(null);
    const yammerRef = (0, react_1.useRef)(null);
    const [isJsonEmbedModalOpen, setIsJsonEmbedModalOpen] = (0, react_1.useState)(false);
    // Utility function to get share options based on subdomain
    function getShareOptions(subDomain) {
        // Start with a copy of the default share options
        const options = Object.assign({}, actionShareButtonsTypes_1.defaultShareOptions);
        // Check if the subdomain has specific disable options
        const disableOptions = actionShareButtonsTypes_1.subdomainsDisableOptionsDict[subDomain];
        // If disable options exist, apply them to the options
        if (disableOptions) {
            for (const key in disableOptions) {
                if (disableOptions[key] === false) {
                    options[key] = false;
                }
            }
        }
        return options;
    }
    // const shareOptions = getShareOptions(getMasterConfig().subDomain);
    const shareOptions = getShareOptions((0, master_1.getMasterConfig)().subDomain);
    const showEmbedCredentialOption = (_c = ((((_a = props.details) === null || _a === void 0 ? void 0 : _a.certificateDesign) && shareOptions.embedCertificate) ||
        (((_b = props.details) === null || _b === void 0 ? void 0 : _b.badgeDesign) && shareOptions.embedBadge))) !== null && _c !== void 0 ? _c : false;
    const toggleShareDropdown = () => {
        setShareDropdownOpen((prev) => !prev);
    };
    const triggerEvent = shareDropdownOpen ? toggleShareDropdown : () => { };
    const moreRef = (0, react_detect_click_outside_1.useDetectClickOutside)({
        onTriggered: triggerEvent,
    });
    const handleClick = (sharingFor) => __awaiter(this, void 0, void 0, function* () {
        var _d;
        if (props.isCollection)
            return;
        if (disclosure) {
            const shareType = constants_2.VelocityEventLogs[`DisclosureShare${sharingFor[0].toUpperCase() + sharingFor.slice(1)}`];
            (0, Vcl_1.logVelocityEvent)(shareType, disclosureId);
        }
        else {
            (_d = props.optimizedMixpanel) === null || _d === void 0 ? void 0 : _d.track("Share Credential", {
                credential_no: props.credential_no,
                sharingFor: sharingFor,
                isLogged: props.userMeta.logged,
                ownership: props.isLoggedInUser,
            });
            yield (0, Events_1.logShareEventAnon)(props.credential_no, sharingFor, props.organization_id);
        }
    });
    const handleInfoModal = (sharingFor) => {
        setSharingFor(sharingFor);
        props.openShareInfoModal();
    };
    const shareOnYammer = () => {
        handleClick("yammer");
        window.yam.platform.yammerShareOpenPopup({
            defaultMessage: disclosure ? disclosureShareText : handleDesc("yammer"),
            pageUrl: disclosure ? disclosureUrl : window.location.href,
        });
    };
    const copyEmbedLink = (link, isBadge) => __awaiter(this, void 0, void 0, function* () {
        var _e;
        const el = document.createElement("textarea");
        el.value = link;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        el.setSelectionRange(0, 99999);
        document.execCommand("copy");
        document.body.removeChild(el);
        (_e = props.optimizedMixpanel) === null || _e === void 0 ? void 0 : _e.track("Embed Credential", {
            credential_no: props.credential_no,
            isBadge: isBadge,
            isLogged: props.userMeta.logged,
            ownership: props.isLoggedInUser,
        });
        if (isBadge) {
            (0, Notification_1.default)({
                type: "success",
                text: props.translate("badgeLinkCopied"),
            });
        }
        else {
            (0, Notification_1.default)({
                type: "success",
                text: props.translate("linkCopied"),
            });
        }
    });
    const handleVelocityDesc = () => {
        var _a, _b;
        let desc = "";
        if (disclosure) {
            setDisclosureId(disclosure.id);
            setDisclosureUrl(`${window.origin}/${(_b = (_a = props.activeLanguage) === null || _a === void 0 ? void 0 : _a.code) !== null && _b !== void 0 ? _b : "en"}/disclosure/${disclosure.id}`);
            if (props.activeLanguage && props.activeLanguage.code === "tr")
                desc = `Verified Wallet'da depolanan ve ${props.issuedBy} tarafından aracılığıyla verilen ${props.credentialTitle} başlıklı dijital sertifika/rozetime göz at!`;
            else
                desc = `Check out my ${props.credentialTitle} digital credential issued by ${props.issuedBy} and stored within Verified Wallet!`;
        }
        setDisclosureShareText(desc);
    };
    (0, react_1.useEffect)(() => {
        if (props.shareDisclosure)
            setDisclosure(props.shareDisclosure);
    }, [props.shareDisclosure]);
    (0, react_1.useEffect)(() => {
        if (sharingFor && disclosure && !props.dialogOpen) {
            handleVelocityDesc();
        }
        else {
            setSharingFor("");
            setDisclosure(null);
        }
    }, [disclosure]);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (disclosureId && disclosureUrl && disclosureShareText)
            switch (sharingFor) {
                case "twitter":
                    (_a = props.optimizedMixpanel) === null || _a === void 0 ? void 0 : _a.track("Share Credential", {
                        credential_no: props.credential_no,
                        sharingFor: "twitter",
                        isVelocityCredential: true,
                        isLogged: props.userMeta.logged,
                        ownership: props.isLoggedInUser,
                    });
                    (_b = twitterRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    break;
                case "facebook":
                    (_c = props.optimizedMixpanel) === null || _c === void 0 ? void 0 : _c.track("Share Credential", {
                        credential_no: props.credential_no,
                        sharingFor: "facebook",
                        isVelocityCredential: true,
                        isLogged: props.userMeta.logged,
                        ownership: props.isLoggedInUser,
                    });
                    (_d = facebookRef.current) === null || _d === void 0 ? void 0 : _d.click();
                    break;
                case "xing":
                    (_e = props.optimizedMixpanel) === null || _e === void 0 ? void 0 : _e.track("Share Credential", {
                        credential_no: props.credential_no,
                        sharingFor: "xing",
                        isVelocityCredential: true,
                        isLogged: props.userMeta.logged,
                        ownership: props.isLoggedInUser,
                    });
                    (_f = xingRef.current) === null || _f === void 0 ? void 0 : _f.click();
                    break;
                case "whatsapp":
                    (_g = props.optimizedMixpanel) === null || _g === void 0 ? void 0 : _g.track("Share Credential", {
                        credential_no: props.credential_no,
                        sharingFor: "whatsapp",
                        isVelocityCredential: true,
                        isLogged: props.userMeta.logged,
                        ownership: props.isLoggedInUser,
                    });
                    (_h = whatsappRef.current) === null || _h === void 0 ? void 0 : _h.click();
                    break;
                case "yammer":
                    (_j = props.optimizedMixpanel) === null || _j === void 0 ? void 0 : _j.track("Share Credential", {
                        credential_no: props.credential_no,
                        sharingFor: "yammer",
                        isVelocityCredential: true,
                        isLogged: props.userMeta.logged,
                        ownership: props.isLoggedInUser,
                    });
                    (_k = yammerRef.current) === null || _k === void 0 ? void 0 : _k.click();
                    break;
                default:
                    break;
            }
        setDisclosureId(0);
        setDisclosureUrl("");
        setDisclosureShareText("");
        setSharingFor("");
        setDisclosure(null);
    }, [disclosureId, disclosureUrl, disclosureShareText]);
    const handleDesc = (tag) => {
        var _a;
        const skillTags = (props.skills &&
            props.skills.reduce((tags, skill) => {
                return (tags += `#${skill.title
                    .toLocaleLowerCase()
                    .replace(/\s+/g, "")} `);
            }, "")) ||
            "";
        let via = "@" + (0, ElementBaseConfig_1.getElementkitConfig)().commonShareVia;
        if (tag === "linkedin") {
            via = (0, ElementBaseConfig_1.getElementkitConfig)().linkedinShareVia;
        }
        else if (tag === "facebook") {
            if (props.activeLanguage && props.activeLanguage.code === "tr")
                via = (0, ElementBaseConfig_1.getElementkitConfig)().facebookShareViaTr;
            else
                via = (0, ElementBaseConfig_1.getElementkitConfig)().facebookShareVia;
        }
        else if (tag === "twitter") {
            if (props.activeLanguage && props.activeLanguage.code === "tr")
                via = (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareViaTr;
            else
                via = (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareVia;
        }
        else
            via = (0, ElementBaseConfig_1.getElementkitConfig)().commonShareVia;
        if (props.activeLanguage && props.activeLanguage.code === "tr")
            return props.shareText
                ? props.shareText
                : `${props.issuedBy} tarafından ${via} aracılığıyla verilen ${props.credentialTitle} başlıklı dijital sertifika/rozetime göz at!\n${skillTags}\n`;
        else
            return ((_a = constants_1.OrganizationBasedShareTexts.get(props.organization_id)) !== null && _a !== void 0 ? _a : (props.shareText ||
                `Check out my ${props.credentialTitle} digital certificate/badge issued by ${props.issuedBy} via ${via}!\n${skillTags}\n`));
    };
    const getEmbedLink = (isBadge) => __awaiter(this, void 0, void 0, function* () {
        const config = (0, master_1.getMasterConfig)();
        let memberLink = "";
        if (config.subDomain === constants_1.Subdomains.nationalBlackLawyers ||
            config.subDomain === constants_1.Subdomains.nationalTrialLawyers) {
            memberLink = yield (0, Certificate_1.getMemberLink)(props.credential_no);
        }
        let embedLink = `<a target="blank" href="${memberLink || window.location.href}">
		<img src="${isBadge ? props.badgeUrl : props.certUrl}" alt="">
	  </a>`;
        return embedLink;
    });
    function handleEmbedLinksAndOpenModal() {
        var _a, _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function* () {
            if (((_a = props.details) === null || _a === void 0 ? void 0 : _a.certificateDesign) && shareOptions.embedCertificate) {
                setCertificateEmbedLink(yield getEmbedLink(false));
            }
            if (((_b = props.details) === null || _b === void 0 ? void 0 : _b.badgeDesign) && shareOptions.embedBadge) {
                setBadgeEmbedLink(yield getEmbedLink(true));
            }
            (_c = props.optimizedMixpanel) === null || _c === void 0 ? void 0 : _c.track("Embed Credential Modal Opened", {
                credential_no: props.credential_no,
                isLogged: props.userMeta.logged,
                ownership: props.isLoggedInUser,
                isCertificate: ((_d = props.details) === null || _d === void 0 ? void 0 : _d.certificateDesign) ? true : false,
                isBadge: ((_e = props.details) === null || _e === void 0 ? void 0 : _e.badgeDesign) ? true : false,
            });
            setIsJsonEmbedModalOpen(true);
        });
    }
    return props.isMobile ? (react_1.default.createElement("div", { className: "social-row" },
        react_1.default.createElement(ImsJsonEmbedModal_1.default, Object.assign({}, props, { type: "embed", jsonOptions: undefined, hideModal: () => setIsJsonEmbedModalOpen(false), isJsonEmbedModalOpen: isJsonEmbedModalOpen, isMobile: props.isMobile, embedOptions: {
                copyEmbedLink: copyEmbedLink,
                certificateEmbedLink: certificateEmbedLink,
                badgeEmbedLink: badgeEmbedLink,
            } })),
        shareOptions.x && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement(react_share_1.TwitterShareButton, { ref: twitterRef, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                        ? () => handleInfoModal("twitter")
                        : () => handleClick("twitter"), title: disclosure && disclosureShareText
                        ? disclosureShareText
                        : handleDesc("twitter"), related: (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareRelatedTags, url: disclosure && disclosureUrl ? disclosureUrl : props.shareUrl, className: "social-icon-container", openShareDialogOnClick: !props.isVelocityCredential ||
                        !!(props.isVelocityCredential && disclosure && sharingFor) }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, height: 50, width: 59, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), onClickAction: () => { } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: x_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 21, height: 21 })) }))),
        shareOptions.facebook && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement(react_share_1.FacebookShareButton, { ref: facebookRef, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                        ? () => handleInfoModal("facebook")
                        : () => handleClick("facebook"), quote: disclosure && disclosureShareText
                        ? disclosureShareText
                        : handleDesc("facebook"), url: disclosure && disclosureUrl ? disclosureUrl : props.shareUrl, className: "social-icon-container", openShareDialogOnClick: !props.isVelocityCredential ||
                        !!(props.isVelocityCredential && disclosure && sharingFor) }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 50, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), disabled: props.isDisabledByMandatoryClaiming, width: 59, onClickAction: () => { } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: facebook_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 11, height: 21 })) }))),
        shareOptions.xing && (react_1.default.createElement(react_1.default.Fragment, null, props.isVelocityCredential && (!disclosure || !sharingFor) ? (react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, height: 50, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), width: 59, onClickAction: () => {
                handleInfoModal("xing");
            } },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 18, height: 21 }))) : (react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement("a", { ref: xingRef, onClick: () => handleClick("xing"), target: "_blank", href: `https://www.xing.com/spi/shares/new?url=${disclosure && disclosureUrl ? disclosureUrl : props.shareUrl}`, title: "Share on Xing", rel: "nofollow noopener noreferrer", className: "social-icon-container" }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), height: 50, width: 59, onClickAction: () => { } },
                react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 18, height: 21 })) })))),
        shareOptions.whatsapp && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement(react_share_1.WhatsappShareButton, { ref: whatsappRef, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                        ? () => handleInfoModal("whatsapp")
                        : () => handleClick("whatsapp"), title: disclosure && disclosureShareText
                        ? disclosureShareText
                        : handleDesc("whatsapp"), url: disclosure && disclosureUrl ? disclosureUrl : props.shareUrl, openShareDialogOnClick: !props.isVelocityCredential ||
                        !!(props.isVelocityCredential && disclosure && sharingFor), className: "social-icon-container" }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 50, width: 59, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), disabled: props.isDisabledByMandatoryClaiming, onClickAction: () => { } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: whatsapp_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 21, height: 20 })) }))),
        shareOptions.yammer && (react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement("div", { ref: yammerRef, className: "share-option", onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                    ? () => handleInfoModal("yammer")
                    : shareOnYammer }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 50, width: 59, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), disabled: props.isDisabledByMandatoryClaiming, onClickAction: () => { } },
                react_1.default.createElement(react_svg_1.ReactSVG, { src: yammer_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 20, height: 17 })) })),
        showEmbedCredentialOption && (react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), height: 50, width: 59, onClickAction: () => {
                handleEmbedLinksAndOpenModal();
            } },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: embed_credential_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 22, height: 15 }))))) : (react_1.default.createElement("div", { className: "social-row" },
        react_1.default.createElement(ImsJsonEmbedModal_1.default, Object.assign({}, props, { type: "embed", jsonOptions: undefined, hideModal: () => setIsJsonEmbedModalOpen(false), isJsonEmbedModalOpen: isJsonEmbedModalOpen, isMobile: props.isMobile, embedOptions: {
                copyEmbedLink: copyEmbedLink,
                certificateEmbedLink: certificateEmbedLink,
                badgeEmbedLink: badgeEmbedLink,
            } })),
        shareOptions.x && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement(react_share_1.TwitterShareButton, { ref: twitterRef, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                        ? () => handleInfoModal("twitter")
                        : () => handleClick("twitter"), title: disclosure && disclosureShareText
                        ? disclosureShareText
                        : handleDesc("twitter"), related: (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareRelatedTags, url: disclosure && disclosureUrl ? disclosureUrl : props.shareUrl, className: "social-icon-container", openShareDialogOnClick: !props.isVelocityCredential ||
                        !!(props.isVelocityCredential && disclosure && sharingFor) }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, height: 50, width: 59, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), onClickAction: () => { } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: x_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 21, height: 21 })) }))),
        shareOptions.facebook && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement(react_share_1.FacebookShareButton, { ref: facebookRef, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                        ? () => handleInfoModal("facebook")
                        : () => handleClick("facebook"), quote: disclosure && disclosureShareText
                        ? disclosureShareText
                        : handleDesc("facebook"), url: disclosure && disclosureUrl ? disclosureUrl : props.shareUrl, className: "social-icon-container", openShareDialogOnClick: !props.isVelocityCredential ||
                        !!(props.isVelocityCredential && disclosure && sharingFor) }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 50, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), disabled: props.isDisabledByMandatoryClaiming, width: 59, onClickAction: () => { } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: facebook_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 11, height: 21 })) }))),
        shareOptions.xing && (react_1.default.createElement(react_1.default.Fragment, null, props.isVelocityCredential && (!disclosure || !sharingFor) ? (react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, height: 50, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), width: 59, onClickAction: () => {
                handleInfoModal("xing");
            } },
            react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 18, height: 21 }))) : (react_1.default.createElement(ConditionalWrapper_1.default, { condition: !props.isDisabledByMandatoryClaiming, wrapper: (children) => (react_1.default.createElement("a", { ref: xingRef, onClick: () => handleClick("xing"), target: "_blank", href: `https://www.xing.com/spi/shares/new?url=${disclosure && disclosureUrl ? disclosureUrl : props.shareUrl}`, title: "Share on Xing", rel: "nofollow noopener noreferrer", className: "social-icon-container" }, children)), children: react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), height: 50, width: 59, onClickAction: () => { } },
                react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 18, height: 21 })) })))),
        !shareOptions.whatsapp &&
            !shareOptions.yammer &&
            !shareOptions.embedCertificate &&
            !shareOptions.embedBadge ? null : (react_1.default.createElement("div", { ref: props.isVelocityCredential && sharingFor ? null : moreRef },
            react_1.default.createElement("div", { className: "social-icon-container" },
                react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, disabled: props.isDisabledByMandatoryClaiming, disabledButtonTooltipOptions: props.getDisabledTooltipOptions(), height: 50, width: 59, onClickAction: () => {
                        toggleShareDropdown();
                    } },
                    react_1.default.createElement(react_svg_1.ReactSVG, { src: three_dot_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 21, height: 5 })),
                shareDropdownOpen && (react_1.default.createElement("div", { className: "more-div" },
                    shareOptions.whatsapp && (react_1.default.createElement(react_share_1.WhatsappShareButton, { ref: whatsappRef, style: { width: "100%" }, onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                            ? () => handleInfoModal("whatsapp")
                            : () => handleClick("whatsapp"), title: disclosure && disclosureShareText
                            ? disclosureShareText
                            : handleDesc("whatsapp"), url: disclosure && disclosureUrl
                            ? disclosureUrl
                            : props.shareUrl, openShareDialogOnClick: !props.isVelocityCredential ||
                            !!(props.isVelocityCredential && disclosure && sharingFor), className: "share-option" },
                        react_1.default.createElement("span", null, "Whatsapp"),
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: whatsapp_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 21, height: 20 }))),
                    shareOptions.yammer && (react_1.default.createElement("div", { ref: yammerRef, className: "share-option", onClick: props.isVelocityCredential && (!disclosure || !sharingFor)
                            ? () => handleInfoModal("yammer")
                            : shareOnYammer },
                        react_1.default.createElement("span", null, "Yammer"),
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: yammer_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 20, height: 17 }))),
                    showEmbedCredentialOption && (react_1.default.createElement("div", { className: "share-option", onClick: handleEmbedLinksAndOpenModal },
                        react_1.default.createElement("span", null, props.translate("embedCredential").toString()),
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: embed_credential_svg_1.default, className: "customizable-icon social-icon", wrapper: "svg", width: 22, height: 15 }))))))))));
}
exports.default = ActionShareButtons;
